import { Component, OnInit } from '@angular/core';
import { DashboardModel } from 'src/app/shared/models/dashboard/dashboard-model';
import { DashboardService } from 'src/app/shared/services/dashboard.service';

@Component({
  selector: 'app-home-supplier',
  templateUrl: './home-supplier.component.html',
  styles: []
})
export class HomeSupplierComponent implements OnInit {

  public dashboardItems: DashboardModel[];

  constructor(
    private dashboardService: DashboardService,
  ) { }

  ngOnInit() {
    this.getAllItems();
  }

  getAllItems() {
    this.dashboardService.getDashboradItems().subscribe((res) => {
      this.dashboardItems = res;
    });
  }

  getCountFromTitle(title: string): number {
    if (this.dashboardItems) {
      const itemWithSameNameAsTitle = this.dashboardItems.find(item => {
        return item.title === title;
      });

      return itemWithSameNameAsTitle ? itemWithSameNameAsTitle.count : 0;
    }

    return 0;
  }

}
